import { Injectable, inject } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { FluxoSelect } from "../model/fluxo/fluxo-select-model";
import { FluxoCompleto } from "../model/fluxo/fluxo-completo-mode";
import { FluxoBusca } from "../model/fluxo/fluxo-busca-model";
import { FluxoSalvarModel } from "../model/fluxo/fluxo-salvar-model";
import {TipoFluxoEnum} from '../enum/tipo-fluxo.enum';

@Injectable({
  providedIn: 'root'
})
export class FluxoService {
  private readonly http = inject(HttpClient);

  urlBase: string = environment.urlBase.concat('/fluxo');

  salvar(fluxo: FluxoSalvarModel): Observable<boolean> {
    return this.http.post<boolean>(`${this.urlBase}/salvar`, fluxo);
  }

  buscar(): Observable<FluxoBusca[]>{
    return this.http.get<FluxoBusca[]>(`${this.urlBase}/buscar`);
  }

  buscarPeloTipo(tipo: TipoFluxoEnum[]): Observable<FluxoBusca[]>{
    return this.http.patch<FluxoBusca[]>(`${this.urlBase}/buscar/tipos`, tipo);
  }

  buscarSelectPeloTipo(tipo: TipoFluxoEnum[]): Observable<FluxoSelect[]>{
    return this.http.patch<FluxoSelect[]>(`${this.urlBase}/buscar-select/tipos`, tipo);
  }

  buscarFluxoCompletoPorId(fluxoId: number): Observable<FluxoCompleto>{
    return this.http.get<FluxoCompleto>(`${this.urlBase}/buscar/${fluxoId}`);
  }

  buscarFluxoSelect(): Observable<FluxoSelect[]>{
    return this.http.get<FluxoSelect[]>(`${this.urlBase}/buscar-select`);
  }

  buscarFluxosSelectQuePossueEtapa(): Observable<FluxoSelect[]>{
    return this.http.get<FluxoSelect[]>(`${this.urlBase}/buscar-select/possue-etapa`);
  }

  buscarFluxoComTipoSelect(): Observable<FluxoSelect[]>{
    return this.http.get<FluxoSelect[]>(`${this.urlBase}/buscar-select-tipo`);
  }

  buscarFluxoErroSelect(): Observable<FluxoSelect[]>{
    return this.http.get<FluxoSelect[]>(`${this.urlBase}/buscar-select-erro`);
  }

  clonarFluxo(fluxoId: number): Observable<number> {
    return this.http.get<number>(`${this.urlBase}/clonar-fluxo/${fluxoId}`);
  }

  alterarStatusPesquisaPeloFluxoId(fluxoId: number, status: any): Observable<boolean> {
    return this.http.put<boolean>(`${this.urlBase}/alterar/status-fluxo/${fluxoId}`, status);
  }
}
